<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-btn v-if="isNew" slot="activator" absolute dark fab bottom right color="pink">
      <v-icon>add</v-icon>
    </v-btn>

    <v-btn v-else slot="activator" absolute dark fab bottom right color="pink">
      <v-icon>create</v-icon>
    </v-btn>

    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-title>
          <span class="headline">{{headline}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Organization Name*"
                  v-model="name"
                  :rules="nameRules"
                  required
                  hint="Name of this National Organization"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Primary Contact Email*"
                  v-model="email"
                  :rules="emailRules"
                  required
                  hint="This address will be sent an invite to manage this organization"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Web Address*"
                  v-model="url"
                  :rules="urlRule"
                  required
                  hint="Web URL for this National Organization's Competitions"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
/*global firebase*/
export default {
  props: {
    isNew: Boolean,
    id: String,
    obj: Object
  },
  data: () => ({
    dialog: false,
    valid: true,
    name: "",
    nameRules: [v => !!v || "Name is required"],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    url: "",
    urlRule: [
      v => !!v || "URL is required",
      v => /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(v) || "URL must be valid"
    ],
    headline: ""
  }),
  created() {
    if (this.isNew) {
      this.headline = "New National Organization";
    } else {
      this.headline = "Edit National Organization";
      this.name = this.obj.name;
      this.email = this.obj.email;
      this.url = this.obj.url;
    }
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        let submitData = {
          name: this.name,
          email: this.email.toLowerCase(),
          url: this.url,
          invited: false
        };

        if (this.isNew) {
          let newOrgKey = firebase
            .database()
            .ref()
            .child("natorgs")
            .push(submitData).key;
          console.log("created natorg with key: " + newOrgKey);
          // clear form
          this.$refs.form.reset();
        } else {
          // update
          firebase
            .database()
            .ref("/natorgs/" + this.id)
            .update(submitData);
        }
        // close dialog
        this.dialog = false;
      }
    }
  }
};
</script>
